
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <!-- this is only shown for selenium tests \n         and does not need to be localized -->\n    <h1 id=\"fxa-clear-storage-header\">Browser storage is cleared</h1>\n  </header>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  